import React, { Component } from "react";
import Img from "react-image";
import Close from "../../../../Icons/Close";
import iconValider from "../../../../styles/img/icon-check-white.svg";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment";
import {
  TimePicker,
  DatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import { EditEvent } from "./Evenements.ducks";
import { DeleteEvent } from "./Evenements.ducks";
import { connect } from "react-redux";
import _ from "lodash";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import { withTranslation } from 'react-i18next';
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
class ModaleEditEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventTitle: "",
      eventDate: "",
      selectedStartTime: moment(),
      startTime: "",
      disabled: false,
      inviteParents: false,
      styleFadeIn: true,
      formErrors: {
        eventTitle: "",
        eventDate: "",
        startTime: "",
      },
      opacity: { opacity: 0.25, pointerEvents: "none" },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleSubmitEvent = this.handleSubmitEvent.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.handleChangeParticipant = this.handleChangeParticipant.bind(this);
  }

  componentDidMount() {
    var event = this.props.event;
    this.setState({
      eventTitle: event.titre,
      eventDate: moment(event.dateTime),
      offset: moment(event.dateTime).utcOffset(),
      selectedStartTime: moment(event.dateTime),
      inviteParents: event.parentsInivites,
    });
  }
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      if (
        !_.isEmpty(this.state.eventTitle) &&
        !_.isEmpty(this.state.eventDate) &&
        !_.isEmpty(this.state.selectedStartTime)
      ) {
        this.setState({ opacity: { opacity: 1 } });
      } else {
        this.setState({ opacity: { opacity: 0.25 } });
      }
    });
  };
  handleStartTimeChange = (time) => {
    this.setState(
      { selectedStartTime: moment(time), startTime: time.format("LT") },
      () => {
        if (
          !_.isEmpty(this.state.eventDate) ||
          !_.isEmpty(this.state.eventTitle) ||
          !_.isEmpty(this.state.selectedStartTime)
        ) {
          this.setState({ opacity: { opacity: 1 } });
        } else {
          this.setState({ opacity: { opacity: 0.25 } });
        }
      }
    );
  };

  handleChangeDate = (date) => {
    this.setState({ eventDate: moment(date) }, () => {
      if (
        !_.isEmpty(this.state.eventDate) ||
        !_.isEmpty(this.state.eventTitle) ||
        !_.isEmpty(this.state.selectedStartTime)
      ) {
        this.setState({ opacity: { opacity: 1 } });
      } else {
        this.setState({ opacity: { opacity: 0.25 } });
      }
    });
  };

  handleChangeParticipant = (name) => (event) => {
    this.setState((prevState) => ({
      inviteParents: !prevState.inviteParents,
    }));
    if (
      !_.isEmpty(this.state.eventTitle) &&
      !_.isEmpty(this.state.eventDate) &&
      !_.isEmpty(this.state.selectedStartTime)
    ) {
      this.setState({ opacity: { opacity: 1 } });
    } else {
      this.setState({ opacity: { opacity: 0.25 } });
    }
  };

  handleSubmitEvent = (e) => {
    e.preventDefault();
    let dateFormat = moment(this.state.eventDate).format("YYYY-MM-DD");
    let timeFormat = moment(this.state.selectedStartTime, "HH[h]mm").format(
      "HH:mm:ssZ"
    );
    let TimeDate = dateFormat + "T" + timeFormat;
    let validTitle = !_.isEmpty(this.state.eventTitle)
      ? ""
      : "Ce champ est obligatoire";
    let validDate = !_.isEmpty(this.state.eventDate)
      ? ""
      : "Ce champ est obligatoire";
    let validTime = !_.isEmpty(timeFormat) ? "" : "Ce champ est obligatoire";
    let formValid =
      _.isEmpty(validTitle) && _.isEmpty(validDate) && _.isEmpty(validTime);
    if (
      !_.isEmpty(this.state.eventDate) &&
      !_.isEmpty(this.state.eventTitle) &&
      !_.isEmpty(this.state.selectedStartTime) &&
      moment(this.state.eventDate).isSameOrAfter(moment(), "day")
    ) {
      let data = {
        dateTime: TimeDate,
        description: "description",
        inviteParents: this.state.inviteParents,
        titre: this.state.eventTitle,
      };
      this.props.EditEvent(
        localStorage.getItem("token"),
        data,
        this.props.eventId,
        this.props.offset
      );
      this.setState({
        styleFadeIn: false,
        formErrors: {
          eventTitle: validTitle,
          date: validDate,
          time: validTime,
        },
      });
      setTimeout(() => {
        this.props.CloseModalEdit();
      }, 400);
    }
  };
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }

  closeAddModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.CloseModalEdit();
    }, 400);
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  render() {
    const { t } = this.props;
    return (
      <StyleRoot>
        <div
          className="modal fade modal-skin modalNewEvent show actif"
          id="modalNewEvent"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modalNewEvent"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeAddModal}
                  />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title mt-0 mb-0">
                      {t('events.edit_event')}
                    </h5>

                    <h2>
                      {t('events.title_label')}
                      <small>{t('events.max_chars')}</small>
                    </h2>
                    <div className="row justify-content-center">
                      <div
                        className={`col-12 ${this.errorClass(
                          this.state.formErrors[`eventTitle`]
                        )}`}
                      >
                        <input
                          type="text"
                          maxLength="40"
                          className="form-control box-shadow custom-input"
                          style={{ backgroundColor: "#ffffff" }}
                          name="eventTitle"
                          id="eventTitle"
                          value="Accueil des nouveaux arrivants"
                          value={this.state.eventTitle}
                          onChange={this.handleChange("eventTitle")}
                          disabled={
                            moment(this.state.eventDate).isSameOrBefore(
                              moment(),
                              "day"
                            ) && moment(this.state.eventDate)
                          }
                        />
                        {(() => {
                          if (!_.isEmpty(this.state.formErrors["eventTitle"])) {
                            return <p>{this.state.formErrors["eventTitle"]}</p>;
                          } else {
                            return "";
                          }
                        })()}
                      </div>
                    </div>

                    <h2>{t('events.date_time')}</h2>
                    <div className="row d-flex align-items-center justify-content-center">
                      <div className="col-md-6 col-lg-6">
                        <div className="container-select">
                          <div
                            className={`form-group ${this.errorClass(
                              this.state.formErrors[`date`]
                            )}`}
                          >
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                  autoOk
                                  ampm={false}
                                  format={"DD MMM YYYY"}
                                  value={moment(this.state.eventDate)}
                                  onChange={this.handleChangeDate}
                                  disablePast={moment(
                                    this.state.eventDate
                                  ).isSameOrAfter(moment(), "day")}
                                  disabled={moment(
                                    this.state.eventDate
                                  ).isSameOrBefore(moment(), "day")}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </div>
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["date"])) {
                              return <p>{this.state.formErrors["date"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-6">
                        <div className="container-select">
                          <div className="form-group">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <TimePicker
                                  fullWidth
                                  value={moment(
                                    this.state.selectedStartTime,
                                    "HH[h]mm"
                                  )}
                                  format={"HH[h]mm"}
                                  showTabs={false}
                                  onChange={this.handleStartTimeChange}
                                  ampm={false}
                                  disabled={moment(
                                    this.state.selectedStartTime,
                                    "HH[h]mm"
                                  ).isSameOrBefore(
                                    moment().format("HH[h]mm"),
                                    "hour"
                                  )}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2> {t('events.participants')}</h2>
                    <div className="d-flex align-items-center justify-content-center">
                      <span>{t('common.no')}</span>
                      <label className="switch switch-blue mx-2 mb-0">
                        <input
                          type="checkbox"
                          id="participant"
                          name="inviteParents"
                          onChange={this.handleChangeParticipant(
                            "inviteParents"
                          )}
                          checked={this.state.inviteParents}
                        />

                        <span className="slider round"></span>
                      </label>
                      <span>{t('common.yes')}</span>
                    </div>
                  </section>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="submit"
                      className="btn-gradient btn-valid margin-left col-md-6 col-lg-6"
                      style={{ background: "grey", float: "right" }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.showModaleConfirmationDelete(e);
                      }}
                    >
                      {" "}
                      {t('common.delete')}
                    </button>

                    <button
                      type="submit"
                      className="btn-gradient btn-valid col-md-6 col-lg-6"
                      style={this.state.opacity}
                      onClick={this.handleSubmitEvent}
                    >
                      <IconValider /> {t('common.validate')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { EditEvent, DeleteEvent })(
  withTranslation()(ModaleEditEvent)
);
